export default "__VITE_ASSET__ywzvQyoo__"